import { getValue } from '../../getValue';

const setTitle = (router) => {
  const channel = getValue('channel');

  // 民生银行特殊操作
  if (channel === 'kgcmbc') {
    setTimeout(() => {
      const kgcmbcSetTitle = require('./kgcmbc').default;
      kgcmbcSetTitle(' ', router);
    }, 300);
  }
};

export default setTitle;
